/**
 * UNDA LP deep links — always send UNDA product card / CTA clicks to the
 * full landing page (`product.unda-lp`). Quick Buy and other collection
 * interceptors cannot render that template, which looked like “nothing happens”.
 */
(function () {
  if (window.__undaLpLinksBooted) return;
  window.__undaLpLinksBooted = true;

  function isUndaLpHref(href) {
    return /\/products\/(unda3in1|3in1)(\?|#|$)/i.test(String(href || ''));
  }

  function landingPath() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    if (lang.indexOf('en') === 0) return '/en/products/unda3in1';
    return '/products/unda3in1';
  }

  document.addEventListener(
    'click',
    function (event) {
      var link =
        event.target && event.target.closest
          ? event.target.closest(
              'a[href*="/products/unda3in1"], a[href*="/products/3in1"]'
            )
          : null;
      if (!link) return;
      if (!isUndaLpHref(link.getAttribute('href') || link.href)) return;

      // Leave alone if already on the LP (in-page anchors / same-product links).
      if (/\/products\/(unda3in1|3in1)/i.test(location.pathname) && !link.classList.contains('product-link') && !link.classList.contains('quickbuy-toggle')) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      window.location.assign(landingPath());
    },
    true
  );
})();
